import settings from './settings';
import bank from './bank';
import user from './user';
import signup from './signup';
import navigation from './navigation';
import lookup from './lookup';

export default { settings, bank, user, signup, navigation, lookup };
